import { render, staticRenderFns } from "./task_split.vue?vue&type=template&id=2e924a32&scoped=true"
import script from "./task_split.vue?vue&type=script&lang=js"
export * from "./task_split.vue?vue&type=script&lang=js"
import style0 from "./task_split.vue?vue&type=style&index=0&id=2e924a32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e924a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e924a32')) {
      api.createRecord('2e924a32', component.options)
    } else {
      api.reload('2e924a32', component.options)
    }
    module.hot.accept("./task_split.vue?vue&type=template&id=2e924a32&scoped=true", function () {
      api.rerender('2e924a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/task_split.vue"
export default component.exports